"use client"

import * as React from "react"
import {
  ToastProvider,
  Toast,
  ToastViewport,
  ToastTitle,
  ToastDescription,
  ToastClose,
  subscribe,
  dismissToast,
  type ToastRecord,
} from "@/components/ui/toast"

export function Toaster() {
  const [toasts, setToasts] = React.useState<ToastRecord[]>([])

  React.useEffect(() => {
    const unsub = subscribe((next) => setToasts(next))
    return unsub
  }, [])

  return (
    <ToastProvider swipeDirection="right" duration={5000}>
      {toasts.map((t) => (
        <Toast
          key={t.id}
          variant={t.variant}
          duration={t.duration}
          onOpenChange={(open) => {
            if (!open) dismissToast(t.id)
          }}
        >
          <div className="flex-1">
            {t.title ? <ToastTitle>{t.title}</ToastTitle> : null}
            {t.description ? <ToastDescription>{t.description}</ToastDescription> : null}
          </div>
          <ToastClose />
        </Toast>
      ))}
      <ToastViewport />
    </ToastProvider>
  )
}
